var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "small-12 column" },
    [
      !_vm.showUpload
        ? [
            _c("p", { staticClass: "text-small" }, [
              _vm._v(_vm._s(_vm._f("translate")("txtUploadNotRequired"))),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showUpload
        ? [
            _c("p", { staticClass: "text-small" }, [
              _vm._v(
                _vm._s(
                  _vm._f("translate")(
                    "txtUploadFiles",
                    _vm.globalConfig.shop.currency
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "file-list" },
              _vm._l(_vm.internalFiles, function (file, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "small-12 column" },
                  [
                    _c("PrintFile", {
                      attrs: {
                        filename: file.name,
                        fileid: file.identifier ? file.identifier : file.id,
                        filestatus: file.status,
                        file: file.file,
                        url: file.url,
                      },
                      on: {
                        "delete-file": function ($event) {
                          return _vm.deleteFile(index)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.notSafari
              ? _c(
                  "div",
                  {
                    staticClass:
                      "upload__input d-flex flex-column bg-shade-light pt-3 pb-3 px-2 p-4@medium flex-center text-center",
                    on: {
                      drop: function ($event) {
                        $event.preventDefault()
                        return _vm.dragndropFile.apply(null, arguments)
                      },
                      dragover: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass:
                          "svg-icon upload-icon m-auto svg-icon--xxlarge",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 50.73 33.62",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M40.71 14.63c-.37 0-.74.02-1.11.06l-1.24.13.09-1.24c.02-.3.03-.59.03-.87 0-7-5.69-12.7-12.7-12.7-3.21 0-6.28 1.2-8.63 3.38a12.68 12.68 0 00-4.03 8.28l-.09 1.1-1.09-.15c-.46-.06-.93-.09-1.4-.09C4.73 12.53 0 17.26 0 23.07c0 5.78 4.71 10.51 10.49 10.54H23.55V24.5v-.31c-.09.07-.14.11-.18.15-.68.67-1.36 1.34-2.02 2.03-.51.53-1.08.88-1.83.76-.71-.11-1.23-.51-1.48-1.18-.25-.65-.19-1.3.29-1.83.68-.75 1.42-1.46 2.14-2.19 1.18-1.19 2.37-2.37 3.55-3.56.8-.81 1.98-.81 2.67-.13.79.76 1.56 1.53 2.33 2.31l3.06 3.06c.31.3.62.6.77 1.02a1.9 1.9 0 01-.75 2.23c-.72.46-1.7.38-2.32-.23-.67-.65-1.32-1.32-1.98-1.98-.14-.15-.3-.28-.49-.47v9.42h13.45c5.5-.03 9.97-4.29 9.97-9.49 0-5.22-4.49-9.48-10.02-9.48z",
                            fill: "#cad505",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "label-aligned text-small mt-2" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm._f("translate")("txtUploadArea")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("SkyUploadWrapper", {
              ref: "fileupload",
              attrs: {
                fileuploadid: _vm.fileuploadid,
                "upload-file-extensions": _vm.globalConfig.uploadFileExtensions,
                multiple: true,
                text: _vm._f("translate")("txtUploadPrintFile"),
              },
              on: {
                fileschanged: _vm.startUpload,
                uploadStarts: _vm.uploadStarts,
                updateUploadState: _vm.updateUploadState,
                uploadFinished: _vm.uploadFinished,
                uploadError: _vm.uploadError,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.option.currentInfo.msgType === "INFO"
        ? _c(
            "div",
            {
              staticClass:
                "text-small mt-prj text-info d-flex line-height-12 flex-center",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "mr-2 svg-icon flex-child-fix position-relative t-1px",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0",
                    y: "0",
                    viewBox: "0 0 36 36",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z",
                      fill: "#62b982",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "XMLID_1_",
                      d: "M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z",
                      fill: "#fff",
                    },
                  }),
                ]
              ),
              _vm._v("\n    " + _vm._s(_vm.option.currentInfo.text) + "\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.option.currentInfo.msgType === "ERROR"
        ? _c(
            "div",
            {
              staticClass:
                "text-small mt-prj text-error d-flex line-height-12 flex-center",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "mr-2 svg-icon flex-child-fix position-relative t-1px",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 36 36",
                  },
                },
                [
                  _c("circle", {
                    attrs: { cx: "18", cy: "18", r: "18", fill: "#e94d47" },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                      fill: "#fff",
                    },
                  }),
                ]
              ),
              _vm._v("\n    " + _vm._s(_vm.option.currentInfo.text) + "\n  "),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }